<template>
  <div class="generalPage">
    <isotopegrid v-bind:isotopeProps="isotopeProps"></isotopegrid>
    <contact></contact>
    <henkel-footer></henkel-footer>
  </div>
</template>

<script>
export default {
  created () {
    window.document.title = '威滅Combat 速效藥餌'
    window.scrollTo(0, 0)
  },
  data () {
    return {
      isotopeProps: {
        title: '常見問題',
        desc: '一切由根源入手',
        cardname: 'Q&A',
        showTag: false,
        popup: true,
        popupContents: null,
        openPopup: false,
        list: [{
          name: '購買威滅速效藥餌已一段時間，但至今仍未曾打開包裝紙盒，藥餌是否仍然有效?',
          id: 0,
          imgpath: '',
          link: '/preventiontips/faq/01',
          tag: '',
          html: `
            <h1 class="hdr">購買威滅速效藥餌已一段時間，但至今仍未曾打開包裝紙盒，藥餌是否仍然有效?</h1>
            <p>請留意外包裝上所標示的有效日期，並於有效期前使用。<br/>一般的餌盒份量足夠維持90日，故我們建議每3個月應更換餌盒。當然如果害蟲大批出沒，則可能有需要更換得較為頻繁。</p>
          `
        }, {
          name: '長期使用藥餌，產品的功效會受影響嗎？曱甴/螞蟻會否對藥餌「免疫」?',
          id: 1,
          imgpath: '',
          link: '/preventiontips/faq/02',
          tag: '',
          html: `
            <h1 class="hdr">長期使用藥餌，產品的功效會受影響嗎？曱甴/螞蟻會否對藥餌「免疫」?</h1>
            <p>直至目前為止，仍未有相關的測試研究指出曱甴/螞蟻對藥餌有免疫力。<br/>若長期使用產品後，認為殺滅效果受影響，建議先檢查所放置的餌盒是否已經放置超過三個月。若已經超過三個月，請馬上更換新的藥餌。</p>
          `
        }, {
          name: '威滅藥餌應如何使用？需要把餌盒剪開？',
          id: 2,
          imgpath: '',
          link: '/preventiontips/faq/03',
          tag: '',
          html: `
            <h1 class="hdr">威滅藥餌應如何使用？需要把餌盒剪開？</h1>
            <p>產品內附的餌盒均以組合形式，請先沿膠盒底之虛線分開。並將餌盒背後附有的黏貼紙撕開，貼於相應的地方即可。請留意，並不需要把餌盒刻意剪開，產品有依據曱甴/螞蟻的習性而設計，刻意的破壞反而會影響產品殺滅效果。</p>
          `
        }, {
          name: '威滅是如何發揮功效的?會否經空氣蒸發而發揮藥效?',
          id: 3,
          imgpath: '',
          link: '/preventiontips/faq/04',
          tag: '',
          html: `
            <h1 class="hdr">威滅是如何發揮功效的?會否經空氣蒸發而發揮藥效?</h1>
            <p>威滅所使用的快倍隆屬於固體餌劑，不是經接觸或空氣揮發而有效。餌劑的毒性需要經曱甴/螞蟻進食消化而產生，而餌盒設計只有細小的昆蟲能進入，並且無煙、無臭及無味，絕對安全有效。</p>
          `
        }, {
          name: '如果餌盒濕了會有何影響?',
          id: 4,
          imgpath: '',
          link: '/preventiontips/faq/05',
          tag: '',
          html: `
            <h1 class="hdr">如果餌盒濕了會有何影響?</h1>
            <p>置於威滅餌盒內的藥餌是經測試不溶於水的。藥餌不會因而喪失其效能及釋出異味。但如果藥餌吸水後過度飽和，已變質的藥餌對曱甴/螞蟻之吸引力會減退，產品的功效會受影響，更有可能會滲出餌盒外。</p>
          `
        }, {
          name: '威滅是否可以擺放在任何地方?',
          id: 5,
          imgpath: '',
          link: '/preventiontips/faq/06',
          tag: '',
          html: `
            <h1 class="hdr">威滅是否可以擺放在任何地方?</h1>
            <p>要逹致威滅的最大效用，我們建議按包裝上的說明擺放。但威滅的餌盒設計安全，可以於廣泛範圍使用並不污染地方。</p>
          `
        }, {
          name: '家有寵物，可以使用威滅藥餌嗎？如果寵物不小心接觸/誤服了，會有何影響？',
          id: 6,
          imgpath: '',
          link: '/preventiontips/faq/07',
          tag: '',
          html: `
            <h1 class="hdr">家有寵物，可以使用威滅藥餌嗎？如果寵物不小心接觸/誤服了，會有何影響？</h1>
            <p>可以使用，但請儘量放置於寵物較少接觸的地方。<br/>不過，威滅所使用的有效成份只對昆蟲有害，而且每個藥餌所內含的份量很小，不足以影響一般家居寵物。當然，若果寵物誤服後有異常，請馬上攜同產品標籤延醫冶理。</p>
          `
        }, {
          name: '怎樣處理已使用之藥餌?',
          id: 7,
          imgpath: '',
          link: '/preventiontips/faq/08',
          tag: '',
          html: `
            <h1 class="hdr">怎樣處理已使用之藥餌?</h1>
            <p>按包裝上之指示，可以用紙或膠袋把已使用之餌盒包好，再放置在廢物箱內。</p>
          `
        }, {
          name: '威滅速效曱甴/殺蟻藥餌能否殺滅其他害蟲?',
          id: 8,
          imgpath: '',
          link: '/preventiontips/faq/09',
          tag: '',
          html: `
            <h1 class="hdr">威滅速效曱甴/殺蟻藥餌能否殺滅其他害蟲?</h1>
            <p>威滅速效藥餌是專為曱甴/螞蟻而製造，因此不能保證威滅速效藥餌對其他害蟲有效。</p>
          `
        }, {
          name: '可以在什麼地方購買威滅產品?',
          id: 9,
          imgpath: '',
          link: '/preventiontips/faq/10',
          tag: '',
          html: `
            <h1 class="hdr">可以在什麼地方購買威滅產品?</h1>
            <p>大部份威滅產品於下列商戶有售: 惠康、百佳、一田、AEON、UNY / APITA、HKTVMALL及港澳各藥房藥行。欲知道更多產品銷售地點，請瀏覽本網頁產品詳細資料。</p>
          `
        }, {
          name: '威滅速效殺蟻藥餌能否殺滅白蟻/紅火蟻嗎?',
          id: 10,
          imgpath: '',
          link: '/preventiontips/faq/11',
          tag: '',
          html: `
            <h1 class="hdr">威滅速效殺蟻藥餌能否殺滅白蟻/紅火蟻嗎?</h1>
            <p>威滅速效殺蟻藥餌暫時只能殺滅家中常見的螞蟻，不能夠殺滅其他螞蟻品種，如白蟻/紅火蟻。</p>
          `
        }, {
          name: '為什麼於置威滅速效殺蟻藥餌巳有3星期 , 仍發現蟻群數目没有減少?',
          id: 11,
          imgpath: '',
          link: '/preventiontips/faq/12',
          tag: '',
          html: `
            <h1 class="hdr">為什麼於置威滅速效殺蟻藥餌巳有3星期 , 仍發現蟻群數目没有減少?</h1>
            <p>威滅速效殺蟻藥餌是經過實驗室的一連串測試, 因此產品有一定的效果。但亦可以參考以下螞蟻沒有減少的原因。</p>
            <ol>
              <li>螞蟻為群居性的昆蟲，螞蟻死後，同伴會將藥餌連帶屍體帶回蟻巢，蟻巢可隱藏於不同地方，不容易被發現。</li>
              <li>外在環境因素是我們不能控制的. 如果在威滅殺蟻藥餌附近的環境不潔淨, 蟻群並不易於進入餌盒.</li>
              <li>如果是比較炎熱或潮濕的天氣, 蟻群會以驚人的速度大量繁殖, 在此情況下, 即使之前放置的藥餌餌巳發揮功效, 仍未能把整個蟻群消滅.</li>
            </ol>
          `
        }],
        selected: null,
        sortOption: null,
        filterOption: null,
        filterText: '',
        option: {
          getSortData: {
            id: 'id'
          },
          sortBy: 'id',
          getFilterData: {
            '顯示全部': function () {
              return true
            },
            '螞蟻': function (el) {
              return el.tag.match(/螞蟻$/)
            },
            '曱甴': function (el) {
              return el.tag.match(/曱甴$/)
            }
          }
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../styles/_vars.sass"
@import "../styles/_isotopeGrid.sass"

.generalPage
  padding-top: $topMenu-height

</style>
<style lang="sass">
@import "../styles/_vars.sass"
@import "../styles/_isotopeGridContents.sass"
</style>



// WEBPACK FOOTER //
// PTipsFAQ.vue?42e02cb8